// React
import { Card, Col, Row } from 'reactstrap';
import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';

// Components
import { FloatButton } from '../../../components/floatButton';
import { PageWrapper } from '../../../components/pageWrapper';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import {
  CostCenter as CostCenterDispatch,
  DeleteCostCenter,
} from '../../../store/costCenter/action';
import { DropdownDatatable } from '../../../components/dropdownDatatable';

const CostCenter = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { error, costCenter, success } = useSelector((state) => ({
    error: state.CostCenter.error,
    costCenter: state.CostCenter.costCenters,
    success: state.CostCenter.success,
  }));

  const handleDelete = (id) => {
    dispatch(DeleteCostCenter(id));
  };

  const handleEdit = (values) => {
    const { id } = values;

    history.push(`/financeiro/centros/${id}`);
  };

  useEffect(() => {
    dispatch(CostCenterDispatch());
  }, [dispatch, success]);

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Tipo</span>,
      sortable: false,
      width: '30%',
      selector: (cell) => {
        return (
          <React.Fragment>
            <div className="d-flex align-items-center fw-medium ">
              <Link
                to={`/financeiro/centros/${cell.id}`}
                className="currency_name"
              >
                {cell.name}
              </Link>
            </div>
          </React.Fragment>
        );
      },
    },
  ];
  return (
    <PageWrapper title={'Centro de Custos'}>
      <Row>
        <Col xs={12}>
          <Card>
            <DropdownDatatable
              data={costCenter ? costCenter : []}
              columns={columns}
              title="Centros de custo"
              titleButton="Novo centro de custo"
              pagination
              persistTableHead
              perPage={10}
              isSearchRemote={false}
              actions={[
                {
                  id: 1,
                  name: 'edit',
                  label: 'Editar',
                  onPress: (cellProps) => handleEdit(cellProps),
                  icon: 'la-pen',
                  classNameColorIcon: 'primary',
                },
              ]}
              handleDelete={(cellProps) => handleDelete(cellProps)}
            />
          </Card>
        </Col>
      </Row>

      <FloatButton
        handleButton={() => history.push('/financeiro/centros/novo')}
      />
    </PageWrapper>
  );
};

export default CostCenter;
